import type { Limits } from '@/entities/limits';
import request from '@/shared/api/request';

export const getAccountLimits = (): Promise<Limits> =>
  request<{ limits: Limits }>({
    url: '/account/limits/',
  }).then((res) => res.limits);
